import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { TaskBoard } from '../components/TaskBoard.jsx';

export function MyTasksPage() {
  const [searchParams] = useSearchParams();
  const [tasks, setTasks] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () =>
    apiJson('/api/my/tasks')
      .then(setTasks)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));

  useEffect(() => {
    void load();
  }, []);

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">My tasks</h2>
      <p className="muted small">Open a card to read the instructions, leave a comment, or attach a screenshot.</p>
      {error ? <p className="err">{error}</p> : null}
      {loading ? <p className="muted">Loading…</p> : null}
      {!loading ? (
        <TaskBoard mode="client" tasks={tasks} onChange={setTasks} showProject onError={setError} initialTaskId={searchParams.get('task')} />
      ) : null}
    </div>
  );
}
